import { render, staticRenderFns } from "./ModalSite.vue?vue&type=template&id=28ed35dd&scoped=true&"
import script from "./ModalSite.vue?vue&type=script&lang=js&"
export * from "./ModalSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ed35dd",
  null
  
)

export default component.exports